export const treatments = [
  {
    value: 'eggfreezing',
    name: 'Egg Freezing Cycle',
    cost: 8000,
    description: 'Includes lab work drawn and processed by Main Line Fertility, ultrasounds, egg retrieval, semen analysis, and sperm processing, anesthesia, cryopreservation, and first year of storage.',
    addons: [
      {
        value: 'meds',
        name: 'Medication',
        cost: 6000
      }
    ]
  },
  {
    value: 'ivf-fresh-transfer',
    name: 'IVF Egg Retrieval Cycle and Fresh Transfer',
    cost: 13750,
    description: 'Includes lab work drawn and processed by Main Line Fertility, ultrasounds, egg retrieval, semen analysis, and sperm processing, anesthesia, and a fresh embryo transfer on day 3 or 5 post egg retrieval.',
    addons: [
      {
        value: 'meds',
        name: 'Medication',
        cost: 6000
      }
    ]
  },
  {
    value: 'ivf-with-pgt-and-frozen-embryo-transfer',
    name: 'IVF Egg Retrieval Cycle, PGT and Frozen Embryo Transfer',
    cost: 15950,
    description: 'Includes lab work drawn and processed by Main Line Fertility, ultrasounds, egg retrieval, semen analysis, and sperm processing, anesthesia, embryo biopsy, packaging and genetic testing of biopsied cells.',
    addons: [
      {
        value: 'meds',
        name: 'Medication',
        cost: 6000
      }
    ]
  },
  {
    value: 'ivf-refund',
    name: 'IVF Refund Program',
    cost: 30000,
    description: 'Up to 3 IVF treatment cycles, all cycle monitoring, unlimited frozen embryo transfers, intracytoplasmic sperm injection (ICSI), embryo biopsy for preimplantation genetic testing (PGT-A), cryopreservation and storage of embryos for the first year.',
    addons: [
      {
        value: 'meds',
        name: 'Medication',
        cost: 6000
      }
    ]
  },
  {
    value: 'invocell',
    name: 'Invocell',
    cost: 7499,
    description: 'Includes intravaginal culture device, retrieval, semen analysis, sperm processing, anesthesia, embryo freezing, one year of embryo storage and one embryo transfer.',
    addons: [
      {
        value: 'meds',
        name: 'Medication',
        cost: 6000
      }
    ]
  }
];
